module.exports = __webpack_public_path__ + "img/55.45b94ddd.png";